(() => {
  "use strict";
  console.log("[Secuvy] Blocker srcipt executed");
  //=====================================================
  // Prevent multiple initializations
  //=====================================================
  if (window.__SCRIPT_INTERCEPTOR_INITIALIZED__) return;
  window.__SCRIPT_INTERCEPTOR_INITIALIZED__ = true;
  //=====================================================
  // Match script source (src attribute) against RULES
  //=====================================================
  function matchSrcRule(src) {
    if (!src) return null;

    try {
      const url = new URL(src, location.href);
      const host = url.hostname;
      const file = url.pathname.split("/").pop();
      for (const r of RULES) {
        if (r.a !== "src") continue;
        const domainMatches = host === r.v || host.endsWith(r.v);
        if (!domainMatches) continue;

        // If no file specified → match all scripts from that domain
        if (!r.f || r.f === file) return r;
      }
    } catch (err) {
      // Ignore URL parsing failures
    }

    return null;
  }

  //=====================================================
  // Match <script> element against RULES
  //=====================================================
  function matchElementRule(el) {
    if (!el || el.tagName !== "SCRIPT") return null;

    for (const r of RULES) {
      const attributeValue = el.getAttribute(r.a);
      if (!attributeValue) continue;

      // Match <script id="">
      if (r.a === "id" && attributeValue === r.v) {
        return r;
      }

      // Match <script src="">
      if (r.a === "src") {
        const match = matchSrcRule(attributeValue);
        if (match) return match;
      }
    }

    return null;
  }

  //=====================================================
  // Utility: Get cookie value by name
  //=====================================================
  function getCookie(name) {
    // const cookies = document.cookie.split(";").map(c => c.trim());
    // for (const cookie of cookies) {
    //   if (cookie.startsWith(`${name}=`)) {
    //     return cookie.substring(name.length + 1);
    //   }
    // }
    // return null;
    try {
      return localStorage.getItem(name);
    } catch (err) {
      console.error("[Secuvy] Error getting cookie value:", err);
      return null;
    }
  }

  //=====================================================
  // Determine if the script is allowed based on cookie/geo policy
  //=====================================================
  function isScriptAllowed(rule) {
    let consentState = {};
    const defaultCountry = "US";

    try {
        const cookieValue = getCookie("secuvy");

        if (cookieValue) {
          const decoded = decodeURIComponent(cookieValue);
          consentState = JSON.parse(decoded);
        } else {
          const policy = scriptedGeoPolicy?.[0];
          const matchedGeo = policy.country.includes(window.scriptCountry || defaultCountry);

          const allowed = policy.cookieCategory === "Opt-in" ? matchedGeo : !matchedGeo;
          consentState = { [rule.n]: allowed };
        }
      } catch (err) {
        consentState = {};
      }

    return consentState[rule.n] === true;
  }

  //=====================================================
  // Neutralize or allow execution of script
  //=====================================================
  function neutralizeScript(el, rule) {
    if (!el || el.dataset.neutralized === "1") return;

    el.dataset.neutralized = "1";
    el.setAttribute("data-name", rule.n);
    el.setAttribute("data-type", el.type || "text/javascript");

    const isAllowed = isScriptAllowed(rule);
    el.type = isAllowed ? "text/javascript" : "text/plain";

  }

  //=====================================================
  // Block inline script execution via beforescriptexecute
  //=====================================================
  document.addEventListener(
    "beforescriptexecute",
    e => {
      const el = e.target;

      if (!el || !el.id) return;

      for (const r of RULES) {
        if (r.a === "id" && el.id === r.v) {
          e.preventDefault();
          neutralizeScript(el, r);
          break;
        }
      }
    },
    true,
  );

  //=====================================================
  // Neutralize existing static scripts before they run
  //=====================================================
  [...document.getElementsByTagName("script")].forEach(script => {
    const rule = matchElementRule(script);
    if (rule) neutralizeScript(script, rule);
  });

  //=====================================================
  // Patch document.createElement to catch dynamic script creation
  //=====================================================
  const originalCreateElement = Document.prototype.createElement;
  Document.prototype.createElement = function (tag, opts) {
    const el = originalCreateElement.call(this, tag, opts);

    if (tag.toLowerCase() === "script") {
      Object.defineProperty(el, "src", {
        configurable: true,
        enumerable: true,
        get: () => el.getAttribute("src"),
        set: value => {
          const rule = matchSrcRule(value);
          if (rule) neutralizeScript(el, rule);
          el.setAttribute("src", value);
        },
      });
    }
    return el;
  };

  //=====================================================
  // Patch appendChild to neutralize before a script is added
  //=====================================================
  const originalAppendChild = Element.prototype.appendChild;
  Element.prototype.appendChild = function (node) {
    if (node && node.tagName === "SCRIPT") {
      const rule = matchElementRule(node);
      if (rule) neutralizeScript(node, rule);
    }
    return originalAppendChild.call(this, node);
  };

  //=====================================================
  // Observe DOM for dynamically added scripts
  //=====================================================
  const observer = new MutationObserver(mutations => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue; // only ELEMENT_NODE

        // Direct <script> element
        if (node.tagName === "SCRIPT" && !(node.dataset && node.dataset.neutralized === "1")) {
          const matchedRule = matchElementRule(node);
          if (matchedRule) neutralizeScript(node, matchedRule);
        }

        // Nested scripts inside added elements
        const scriptNodes = node.getElementsByTagName?.("script") || [];
        for (const script of scriptNodes) {
          if (script.dataset?.neutralized === "1") continue;

          const matchedRule = matchElementRule(script);
          if (matchedRule) neutralizeScript(script, matchedRule);
        }
      }
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
